import { render, staticRenderFns } from "./orderDetailItemPrint.vue?vue&type=template&id=a3b849c2&scoped=true&"
import script from "./orderDetailItemPrint.vue?vue&type=script&lang=js&"
export * from "./orderDetailItemPrint.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailItemPrint.vue?vue&type=style&index=0&id=a3b849c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b849c2",
  null
  
)

export default component.exports